import React from "react";

const DisabledOverlay = ({ message = 'Read Only' }) => (
  <div
    style={{
      position: 'absolute',
      inset: 0, // shorthand for top: 0, right: 0, bottom: 0, left: 0
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      pointerEvents: 'auto',
      paddingTop: '25%',
    }}
  >
    <span style={{ color: '#444', fontSize: '1.5em', fontWeight: 'bold' }}>
      {message}
    </span>
  </div>
);

export default DisabledOverlay;